import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
//if component <h1>{this.props.t('lang')}</h1>

function Pic12({ t }) {

    return (
        <div className="mainLayout">
            <div className="mainLayOutInner">
                <br />

                <div className="imageWraper">
                <img src="/images/12.jpg" className="pic1M" alt="pic1" />

                <div className="pic1MDisc">
                    <div>Lyndon Polan, the race, Huile sur panneau de bois, 36x24, 2018</div>
                </div>
                <span className="arrow1"> <Link to="/11">{"<"}</Link> </span><span className="arrow2"> <Link to="/13">{">"}</Link></span>
                </div>

                





            </div>
        </div>
    );
}


export default withTranslation()(Pic12);